// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2MXl_","checkboxCol":"Table_checkboxCol__1Gu--","emailCol":"Table_emailCol__1JiAg","actionCol":"Table_actionCol__28zf_"};